import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { api } from "@/lib/api";

export default function AdminAuditLogs() {
  const [rows, setRows] = useState([]);
  const [stats, setStats] = useState(null);
  const [filter, setFilter] = useState({ module: "", action: "", actor: "" });

  const load = () => {
    const params = {};
    if (filter.module) params.module = filter.module;
    if (filter.action) params.action = filter.action;
    if (filter.actor) params.actor = filter.actor;
    api.get("/admin/audit-logs", { params }).then(r => setRows(r.data));
    api.get("/admin/audit-logs/stats").then(r => setStats(r.data));
  };
  useEffect(() => { load(); }, []);

  return (
    <AdminLayout>
      <h1 className="text-2xl font-bold text-white">Audit Logs</h1>
      <p className="text-slate-400 text-sm mt-1">Immutable, append-only record of administrative and security-sensitive actions.</p>

      {stats && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-6">
          <div className="p-4 bg-slate-900 border border-slate-800 rounded-md"><div className="text-xs text-slate-400 uppercase tracking-wider">Total Events</div><div className="text-2xl font-bold text-white mt-1">{stats.total}</div></div>
          <div className="p-4 bg-slate-900 border border-slate-800 rounded-md"><div className="text-xs text-slate-400 uppercase tracking-wider">Today</div><div className="text-2xl font-bold text-emerald-300 mt-1">{stats.today}</div></div>
          <div className="md:col-span-2 p-4 bg-slate-900 border border-slate-800 rounded-md">
            <div className="text-xs text-slate-400 uppercase tracking-wider mb-2">Top Modules</div>
            <div className="flex flex-wrap gap-2">
              {(stats.modules||[]).map(m => <Badge key={m.module} className="bg-slate-800 border-slate-700 text-slate-200">{m.module}: {m.count}</Badge>)}
            </div>
          </div>
        </div>
      )}

      <Card className="mt-6 p-4 bg-slate-900 border-slate-800">
        <div className="grid md:grid-cols-4 gap-3">
          <Input placeholder="Module (e.g. vs_ai)" value={filter.module} onChange={e=>setFilter({...filter, module:e.target.value})} onBlur={load} className="bg-slate-800 border-slate-700 text-white" data-testid="audit-filter-module"/>
          <Input placeholder="Action" value={filter.action} onChange={e=>setFilter({...filter, action:e.target.value})} onBlur={load} className="bg-slate-800 border-slate-700 text-white" data-testid="audit-filter-action"/>
          <Input placeholder="Actor name / user id" value={filter.actor} onChange={e=>setFilter({...filter, actor:e.target.value})} onBlur={load} className="bg-slate-800 border-slate-700 text-white" data-testid="audit-filter-actor"/>
          <button onClick={load} className="bg-[#F59E0B] text-[#0A2540] font-semibold rounded-md px-4 py-2 hover:bg-[#F59E0B]/90" data-testid="audit-apply">Apply</button>
        </div>
      </Card>

      <Card className="mt-4 p-0 bg-slate-900 border-slate-800 overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="text-slate-400 border-b border-slate-800">
            <tr>{["Time","Actor","Role","Action","Module","Entity","Description"].map(h=><th key={h} className="text-left px-4 py-3 font-semibold">{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} className="border-b border-slate-800 hover:bg-slate-800/30">
                <td className="px-4 py-3 text-slate-200">{new Date(r.created_at).toLocaleString()}</td>
                <td className="px-4 py-3 text-slate-200">{r.actor_name || "—"}</td>
                <td className="px-4 py-3"><Badge className="bg-slate-800 border-slate-700 text-slate-200">{r.actor_role}</Badge></td>
                <td className="px-4 py-3 text-white font-medium">{r.action}</td>
                <td className="px-4 py-3 text-slate-300">{r.module}</td>
                <td className="px-4 py-3 text-slate-400 font-mono text-xs">{r.entity_id}</td>
                <td className="px-4 py-3 text-slate-400">{r.description}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="p-6 text-center text-slate-500">No audit events recorded yet.</td></tr>}
          </tbody>
        </table>
      </Card>
    </AdminLayout>
  );
}
